import AbstractPlatformWindow from "~/operatorApplication/ts/platform/AbstractPlatformWindow";
import AbstractPlatformNotification from "~/operatorApplication/ts/platform/AbstractPlatformNotification";
import OperatorApplicationPlatformInterface
    from "~/operatorApplication/ts/platform/OperatorApplicationPlatformInterface";
import AbstractPlatformUpdater from "~/operatorApplication/ts/platform/AbstractPlatformUpdater";
import UrlParser from "../../../../../nodejs/src/Library/UrlParser";
import {
    ADD_AND_OPEN_CLIENT_BY_USERNAME,
    AddAndOpenClientByUsernamePayloadInterface,
    OperatorApplicationEventManager
} from "~/operatorApplication/ts/OperatorApplicationEventManager";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import {OperatorApplicationConfigInstance} from "~/operatorApplication/ts/service/OperatorApplicationConfig";

export default abstract class AbstractOperatorApplicationPlatform implements OperatorApplicationPlatformInterface {
    private windowInstance: AbstractPlatformWindow;
    private notificationsInstance: AbstractPlatformNotification;
    private updaterInstance?: AbstractPlatformUpdater;

    constructor() {
        this.windowInstance = this.createWindowInstance();
        this.notificationsInstance = this.createNotificationInstance();
        this.updaterInstance = this.createUpdaterInstance();
    }

    initBrand() {

    }

    protected abstract createWindowInstance(): AbstractPlatformWindow;

    protected abstract createNotificationInstance(): AbstractPlatformNotification;

    protected abstract createUpdaterInstance(): AbstractPlatformUpdater | null;

    public abstract get isAutoStartAvailable(): boolean;

    public abstract isAutoStartEnabled(): Promise<boolean>;

    public abstract get isSystemIdleStateAvailable(): boolean


    public abstract setAutoStartEnabled(value: boolean): Promise<void>;

    public abstract getBrandId(): Promise<string>;

    public abstract getDefaultDownloadPath(): Promise<string>;

    get window() {
        return this.windowInstance;
    }

    get notifications() {
        return this.notificationsInstance;
    }

    get updater() {
        return this.updaterInstance;
    }

    get platformId() {
        return "desktop";
    }

    get platformDescr(): string {
        return null;
    }

    protected abstract closeApplication(): void;

    async exit() {
        if (this.updaterInstance && this.updaterInstance.isReadyToUpdate) {
            await this.updaterInstance.make();
        }
    }

    abstract get isNative(): boolean;

    abstract openExternal(url: string): void;

    abstract getSystemIdleState(idleThreshold: number): Promise<'active' | 'idle' | 'locked' | 'unknown'>;

    abstract getSystemIdleTime(): Promise<number>;

    handleAppUrl(url: string, isStartup: boolean = false) {
        try {
            let parse = UrlParser.get(url);
            let searchParams = parse.searchParams;
            if (url.includes('//open-client/') || parse.pathname == '//open-client/' || parse.host === 'open-client') {
                if (OperatorAccountStore.isAuthorized.value) {
                    let username = searchParams.get("username");
                    let payload: AddAndOpenClientByUsernamePayloadInterface = {
                        username
                    };
                    let messageId = searchParams.get("messageId");
                    let dialogId = searchParams.get("dialogId");
                    if (messageId) {
                        let intMessageId = parseInt(messageId);
                        if (intMessageId) {
                            payload.messageId = intMessageId;
                        }
                    }
                    if (!payload.messageId && dialogId) {
                        let intDialogId = parseInt(dialogId);
                        if (intDialogId) {
                            payload.dialogId = intDialogId;
                        }
                    }
                    OperatorApplicationEventManager.emit(ADD_AND_OPEN_CLIENT_BY_USERNAME, payload);
                }
            } else if (url.includes("//open-operator/")) {
                let login = searchParams.get("login");
                let operator = OperatorAccountStore.operatorsDictionary.value[login];
                if (operator) {
                    let payload: AddAndOpenClientByUsernamePayloadInterface = {
                        username: operator.chatId
                    };
                    OperatorApplicationEventManager.emit(ADD_AND_OPEN_CLIENT_BY_USERNAME, payload);
                }
            }
            if (isStartup) {
                let login = searchParams.get("login");
                let password = searchParams.get("password");
                if (typeof login == "string" && typeof password == "string") {
                    if (login.length > 0) {
                        OperatorAccountStore.SET_CREDENTIALS_FOR_AUTH_AFTER_LOAD({
                            login, password
                        });
                    }
                }
                if (searchParams.get("hidden")) {
                    OperatorAccountStore.SET_MINIMIZE_AFTER_STARTUP(true);
                }
                if (searchParams.get("proxy")) {
                    OperatorApplicationConfigInstance.useInternationalHost(true);
                    OperatorApplicationConfigInstance.useInternationalHostIfNeed = async () => {
                    };
                }
            }
        } catch (e) {
        }

    }

    public get isDownloadAvailable(): boolean {
        return this.isPlatformCanDownload() && OperatorApplicationConfigInstance.isDownloadEnabled;
    }

    public abstract isPlatformCanDownload(): boolean;

    public abstract selectDirectory(defaultPath?: string): Promise<string>;

    setSpellcheckLanguages(langCodes: string[]) {

    }

    async getSpellcheckAvailableLanguages(): Promise<{ id: string, descr: string }[]> {
        return [];
    }

    public abstract download(url: string[]): void;

    isPreventContextMenuWithSelectionInChatHistory(hasSelection: boolean): boolean {
        return true;
    }
}

export interface SpellcheckLanguageInterface {
    id: string,
    descr: string
}